<template>
  <div>
    <v-tabs color="secondary" dark>
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab @click="way='money'">&nbsp; &nbsp;Money Transfer - IMPS</v-tab>
      <v-tab @click="way='report'">&nbsp; &nbsp;Transation Report</v-tab>
    </v-tabs>
    <MoneyTransfer v-show="way === 'money'"></MoneyTransfer>
    <DMRReport v-show="way === 'report'"></DMRReport>
  </div>
</template>
<script>
import MoneyTransfer from "../instapay/MoneyTransfer";
import DMRReport from "../instapay/DMRReport";
export default {
  data() {
    return {
      way: "money"
    };
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    dmr() {
      return this.$store.getters.instapay;
    },
    ezpayenable() {
      return this.$store.getters.instapayenable;
    }
  },
  watch: {
    user(value) {
      let vm = this;
      if (vm.user.length == 0) {
        this.$router.push("/account");
      }
    }
  },

  components: {
    MoneyTransfer,
    DMRReport
  },
  mounted() {
    let vm = this;
    if (vm.user.length == 0) {
      vm.$router.push("/account");
    }
    if (!vm.ezpayenable) {
      vm.$router.push("/account");
      return;
    }
    vm.$store.commit("setinstapay", null);
  }
};
</script>
